<template>
  <div class="loans-pipeline__container" :class="{ 'cx-skin': skinOn }">
    <PageHeaderPortal>
      <div class="page-header-left">
        <div class="page-icon">
          <i class="fa-duotone fa-table-cells-large"></i>
        </div>
        <div>
          <h1 class="page-title">Pipeline</h1>
          <p class="page-subtitle">Every loan, every stage, one queue</p>
        </div>
      </div>
    </PageHeaderPortal>

    <div class="loans-pipeline__body">
      <processing />
    </div>
  </div>
</template>

<script>
  import { Window } from '@progress/kendo-vue-dialogs';
  import { Button } from '@progress/kendo-vue-buttons';
  import auth from '../authConfig.js';
  import axios from 'axios';


  import processing from '../components/ProcessingV2.vue';
import PageHeaderPortal from '@/views/PageHeaderPortal.vue';
  // Contacts-pipeline look while the Connect flag is on (assets/css/connectTableSkin.css); style only.
  import '@/assets/css/connectTableSkin.css';
  import { isConnectEnabled } from '@/helpers/connect/connectFeatures.js';
  import apiService from '../api/api.service.js';
  import formatHelpers from '../helpers/formatHelpers.js';

  export default {
    name: 'App',
    components: {
      PageHeaderPortal,

      'window': Window,
      'kbutton': Button,
      "processing": processing
    },
    data() {
      return {
        skinOn: isConnectEnabled(),
        conditionsData: [],
        selectedLoan: '',
        selectedLoanBorrower: '',
        selectedLoanNumber: '',
        isLoading: true,
        visible: true,
        isError: false,
        loaderStatus: "Logging In",
        loanChange: false,
        loandata: [],
        // MSAL
        idTokenClaims: null,
      }
    },
    async created() {

      const msalAppInstance = await auth.init();

      msalAppInstance.handleRedirectPromise().then(async (tokenRes) => {

        if (!tokenRes) {
          if (!auth.user()) {
            auth.login();
          }
        }
      });
    },
    methods: {

    }

  }
</script>

<style scoped>
  .loans-pipeline__container {
    height: 100vh;
    overflow: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .loans-pipeline__body {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
  }

.page-header-left { display: flex; align-items: center; gap: 14px; flex: 0 0 auto; }
.page-icon {
  width: 48px; height: 48px;
  border-radius: 5px;
  background: #123a71;
  color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 20px;
  flex: 0 0 auto;
}
.page-title  { margin: 0; font-size: 20px; font-weight: 700; color: #1f2a44; letter-spacing: -.01em; }
.page-subtitle { margin: 4px 0 0; font-size: 13px; color: #7b8397; font-weight: 500; }
</style>